export const CLIENT_KEYS = {
  ACCESS_LIST: "access-list",
  ACCESS_CONFIG: "access-config",
  ADMIN_USERS: "admin-users",
  ACTIVITY_LOGS: "activity-logs",
  ASSESSMENTS: "assessments",
  BOOKING_APPROVALS: "booking-approvals",
  BUNDLE_SPLITTER: "bundle-splitter",
  ME: "me",
  VINCI_SEARCH: "vinci-search",
  BY_CASE_NUMBER: "get-case-by-case-number",
  CASES: "cases",
  CHECK_EXPORTING_FILES: "check-exporting-files",
  DOCUMENT_REQUESTS: "document-requests",
  PROVIDER_REQUESTS: "provider-requests",
  REQUEST_FORMS: "request-forms",
  CODE_OF_CONDUCT: "code-of-conduct",
  COSMOS: "cosmos",
  DRAFT_STATUS: "draft-status",
  FILES: "files",
  HEALTH: "health",
  OCR_LINES: "ocr-lines",
  REPORT_GENERATOR: "report-generator",
  REPORT_QA: "report-qa",
  RESULT: "result",
  RESPONSES: "responses",
  STATUS: "status",
  TAGS: "tags",
  TASKS: "tasks",
  TEMPLATES: "templates",
  USERS: "users",
};

export const MUTATION_KEYS = {
  BULK_REMOVE_FILES: ["bulk-remove-files"],
} as const;
